module.exports = __webpack_public_path__ + "static/media/logo-xbox.d065e077.svg";